export default __webpack_public_path__ + "static/media/levelTest-Illustration03.19af4fa5.jpg";